// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".picker_c2da {\n  max-height: 50vh;\n  height: 50vh;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/ModuleAdd.scss","ModuleAdd.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,YAAA;ACDJ","file":"ModuleAdd.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.picker {\n    max-height: 50vh;\n    height: 50vh;\n}",".picker {\n  max-height: 50vh;\n  height: 50vh;\n}"]}]);
// Exports
exports.locals = {
	"picker": "picker_c2da"
};
module.exports = exports;
